{
  "agreements": {
    "column": {
      "claim-option": "Option de réclamation",
      "currency": "Devise",
      "description": "Description",
      "more": "plus",
      "number": "N°",
      "type": "Type",
      "valid-from": "Valable à partir du",
      "valid-to": "Valable jusqu'au"
    },
    "header": {
      "intro": "Consultez vos accords en cours. Cliquez sur le bouton « soumettre une réclamation » pour lancer une réclamation.",
      "title": "Aperçu des accords"
    },
    "product": {
      "billback-rate": "Taux Billback / kg.",
      "code": "Code LW",
      "name": "Produits"
    },
    "table": {
      "detail": {
        "contact": "Contact :",
        "lwm-contact": "Contact LW :",
        "download-pdf": "Télécharger l'accord en PDF"
      },
      "empty": "Aucun accord disponible",
      "submit-claim": "Soumettre une réclamation"
    },
    "type": {
      "billback": "Accord Billback QTE"
    }
  },
  "amplify": {
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": "Le mot de passe doit répondre aux exigences suivantes : Longueur minimum du mot de passe de 6 caractères ; majuscules en alphabet latin (A-Z) ; minuscules en alphabet latin (a-z) ; chiffres du système décimal (0-9)\n",
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$; Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6": "2 erreurs de validation détectées : La valeur du \"mot de passe\" ne satisfait pas à la contrainte : Le membre doit répondre au modèle d'expression régulière : ^[\\S]+.*[\\S]+$; La valeur du \"mot de passe\" ne satisfait pas à la contrainte : Le membre doit avoir une longueur égale ou supérieure à 6",
    "Account recovery requires verified contact information": "Le recouvrement de compte nécessite la vérification des coordonnées.",
    "An account with the given email already exists.": "Il existe déjà un compte avec l'e-mail renseigné.",
    "Apply code from MFA app": "Saisissez le code de votre service d'authentification multifactorielle.",
    "Apply code from SMS": "Saisissez le code envoyé à votre appareil mobile.",
    "Back to Sign In": "Retour à l'identification",
    "Cancel": "Annuler",
    "Change Password": "Modifier le mot de passe",
    "Code": "Code",
    "Confirm": "Confirmer",
    "Confirm password": "Confirmer le mot de passe",
    "Confirm Sign In": "Confirmer l'identification",
    "Confirm Sign Up": "Nous vous avons envoyé un code de confirmation par e-mail.",
    "Confirm a Code": "Confirmer un code",
    "Confirmation Code": "Code de confirmation",
    "Create Account": "Créer Compte",
    "Create a new account": "Créer un nouveau compte",
    "Create account": "Créer un compte",
    "Custom auth lambda trigger is not configured for the user pool.": "Mot de passe ne doit pas être vide",
    "Email": "E-mail",
    "Email address": "Adresse e-mail",
    "Enter your Email address": "Saisissez votre adresse e-mail",
    "Enter your password": "Saisissez votre mot de passe",
    "Enter your username": "Saisissez votre identifiant",
    "Forgot Password": "Mot de passe oublié",
    "Forgot your password? ": "Oublié votre mot de passe ?",
    "Have an account? ": "Avez-vous un compte ?",
    "Incorrect username or password": "Identifiant ou mot de passe incorrect",
    "Invalid code received for user": "Code non valide reçu pour l'utilisateur",
    "Invalid password format": "Format invalide du mot de passe",
    "Invalid phone number format": "Format invalide du numéro de téléphone",
    "Loading": "Chargement en cours",
    "Lost your code? ": "Perdu votre code ?",
    "New Password": "Nouveau mot de passe",
    "No account? ": "Pas de compte ?",
    "Password": "Mot de passe  ",
    "Password attempts exceeded": "Vous avez dépassé le nombre de tentatives de saisie du mot de passe ",
    "Phone Number": "Numéro de téléphone",
    "Please confirm your password": "Veuillez confirmer votre mot de passe",
    "Remember this device": "Se souvenir de cet appareil",
    "Resend Code": "Renvoyer le code",
    "Reset password": "Réinitialiser le mot de passe",
    "Reset your password": "Réinitialiser votre mot de passe",
    "Send Code": "Envoyer code",
    "Set MFA": "Configurer AMF",
    "Sign In": "Se connecter",
    "Sign Out": "Se déconnecter",
    "Sign Up": "S'enregistrer",
    "Sign in": "Se connecter",
    "Sign in to your account": "Connectez-vous à votre compte",
    "Skip": "Passer",
    "Submit": "Soumettre",
    "User already exists": "L'utilisateur existe déjà",
    "User does not exist": "L'utilisateur n'existe pas",
    "User does not exist.": "L'utilisateur n'existe pas.",
    "Username": "Identifiant  ",
    "Username cannot be empty": "L'identifiant ne doit pas être vide",
    "Username/client id combination not found.": "La combinaison identifiant/numéro de client n'existe pas.",
    "Verification Code": "Code de vérification",
    "Verify": "Vérifier",
    "Verify Contact": "Vérifier contact",
    "Verify Token": "Vérifier"
  },
  "authentication": {
    "link-corporate": "Aller vers",
    "verification_message": "Nous avons envoyé un code de confirmation à votre adresse e-mail.",
    "warning": {
      "requires-mfa": "Ceci n'est disponible que pour les utilisateurs dont l'authentification multi-facteurs est activée. Vous pouvez configurer votre authentification multifactorielle dans"
    }
  },
  "brand": {
    "name": "Lamb Weston"
  },
  "claims": {
    "column": {
      "amount": "Montant Billback",
      "contract-no": "N° de contrat",
      "description": "Description",
      "info": "Info",
      "posting-date": "Date",
      "status": "Statut",
      "type": "Type"
    },
    "empty": "Aucune réclamation disponible",
    "header": {
      "intro": "Consultez vos réclamations en cours.",
      "title": "Aperçu des réclamations soumises"
    },
    "kg": "KG",
    "new": {
      "confirm-dialog": {
        "button": "Fermer le message",
        "message": "Cher client, merci pour vos informations. Votre réclamation sera examinée et réglée sous 3 à 4 semaines. Pour toute question, veuillez contacter votre interlocuteur commercial LW/M.",
        "title": "Votre réclamation a été soumise"
      },
      "footer": {
        "back": "Retour",
        "next": "Suivant",
        "submit": "Soumettre la réclamation",
        "total-billback-amount": "Montant Billback total",
        "total-claim-amount": "Montant total de la réclamation : ",
        "total-volume": "Volume total : "
      },
      "items": {
        "bags": "Sachets",
        "billback-amount": "Montant Billback",
        "billback-rate": "Taux Billback",
        "boxes": "Cartons",
        "volume": "Volume"
      },
      "new-claim-button": "Soumettre une nouvelle réclamation",
      "repeat-button": {
        "large1": "Vous souhaitez démarrer une autre réclamation ?",
        "large2": "Retour à l'aperçu des réclamations",
        "small": "Aperçu des réclamations"
      },
      "steps": {
        "claim-details": "Renseigner les détails de la réclamation",
        "claim-summary": "Récapitulatif de la réclamation",
        "details": {
          "agreement-details": "Détails de l'accord",
          "applicant": "Demandeur",
          "currency": "Devise :",
          "header": "Détails de la réclamation",
          "valid-range": "Valable du-au : {from} au {to}",
          "wholesale-party": "Grossiste"
        },
        "details-form": {
          "credit-reference": {
            "label": "Référence de crédit",
            "placeholder": "Veuillez indiquer votre référence de crédit"
          },
          "header": "Renseigner les détails de la réclamation",
          "intro": "Veuillez sélectionner les produits pour votre réclamation de remise. Nous vous prions également de nous indiquer le grossiste auprès duquel vous avez commandé vos produits.",
          "period": {
            "clear": "Effacer",
            "label": "Période de réclamation du - au",
            "placeholder": "Veuillez sélectionner votre période de réclamation"
          },
          "wholesale-party": {
            "label": "Grossiste",
            "placeholder": "Veuillez indiquer votre grossiste"
          }
        },
        "proof": {
          "attachment": {
            "label": "Veuillez fournir une preuve d'achat pour tous les articles ajoutés ci-dessus",
            "placeholder": "Glissez-déposez les fichiers ici ou cliquez pour les téléverser.  (max. 25 Mo) {'|'} PDF, JPG, PNG, XLSX, DOCX, MSG pris en charge"
          },
          "header": "Fournir une preuve"
        },
        "summary": {
          "header": "Récapitulatif de votre réclamation ",
          "your-billback-claim": "Votre réclamation Billback"
        }
      }
    },
    "overview": {
      "details": {
        "footer-message": "Pour toute question, veuillez contacter votre interlocuteur commercial LW EMEA.",
        "title": "Aperçu de la réclamation"
      }
    },
    "search-bar": {
      "placeholder": {
        "search": "Recherche en cours …"
      },
      "total": "Total"
    },
    "status": {
      "failed": "Échouée",
      "submitted": "Soumise"
    }
  },
  "container-calculation": {
    "button": {
      "back": "Retourner",
      "calculate": "Calculer",
      "download": "Télécharger",
      "next": "Suivant"
    },
    "download": {
      "download": "Téléchargez le calcul de votre commande ",
      "file-type": "Fichier CSV",
      "intro": {
        "done": "Le calcul de votre commande de conteneurs est terminé !",
        "download": "Vous pouvez télécharger votre calcul de conteneur via le téléchargement CSV."
      },
      "title": "Téléchargement CSV du calcul de la commande"
    },
    "header": {
      "intro": {
        "step-1": "Veuillez choisir si vous souhaitez que nous utilisions une feuille-palette ou des palettes pour votre commande de conteneurs. ",
        "step-2": "Ajoutez les produits souhaités.",
        "step-3": "Le système calculera si des articles de remplissage supplémentaires sont nécessaires pour maximiser l'espace du conteneur."
      },
      "title": "Sélectionner les produits pour le conteneur"
    },
    "load-base": {
      "pallet": "Palettes",
      "sheet": "Feuilles"
    },
    "result": {
      "filled": {
        "description": "veuillez cliquer sur Suivant pour continuer.",
        "message": "Votre sélection actuelle de produits tient dans un conteneur,"
      },
      "initial": {
        "description": "",
        "message": "Nous vous aiderons à exploiter au mieux l’espace disponible dans le conteneur. Veuillez saisir la quantité de palettes, puis cliquer sur Calculer. Le cas échéant, le calculateur vous donnera un feed-back pour optimiser l’espace du conteneur."
      },
      "overfilled": {
        "description": "Nous vous avons fait une suggestion basée sur la plus grande quantité d’articles, que vous pouvez accepter en cliquant sur le bouton orange. Vous êtes libre de faire d’autres ajustements en modifiant la quantité d’un article sur la liste. Cliquez sur Suivant une fois que l’espace du conteneur est rempli.",
        "message": "Des palettes doivent être enlevées pour remplir le conteneur à sa capacité maximale."
      },
      "overfilled-no-product": {
        "description": "Votre sélection actuelle de produits ne tient pas dans l’espace disponible du conteneur. Veuillez réduire votre sélection de produits de {count} palettes.",
        "message": "Vous avez ajouté trop de palettes."
      },
      "totals": {
        "boxes": "Cartons :",
        "kg": "kg",
        "pallets": "Palettes :",
        "title": "Total",
        "weight": "Estimation du poids brut :"
      },
      "underfilled": {
        "description": "Nous vous avons fait une suggestion basée sur la plus grande quantité d’articles.  Vous pouvez accepter cette configuration en cliquant sur le bouton orange. Vous êtes libre de faire d’autres ajustements en modifiant la quantité d’un article sur la liste. Cliquez sur Suivant une fois que l’espace du conteneur est rempli.",
        "message": "Des palettes doivent être ajoutées pour remplir le conteneur à sa capacité maximale."
      }
    },
    "steps": {
      "select-products": "Sélectionnez les produits pour le conteneur",
      "summary": "Téléchargement CSV du calcul de la commande"
    },
    "suggestion": {
      "add": "Ajouter {amount}",
      "reduce": "Réduire {amount}"
    }
  },
  "contracts": {
    "contract": {
      "general": {
        "contract-no": "No. de contrat :",
        "to": "à",
        "total-volume": "Volume total du contrat :",
        "valid-from-to": "Valide de/à"
      }
    },
    "disclaimer": {
      "block-1": {
        "content": "En raison de l'évolution du marché, les informations contenues dans vos contrats de volume peuvent être modifiées. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit. Fusce facilisis sed augue sed maximus. Quisque non leo tempor, elementum tellus accumsan, hendrerit risus. Nam nec efficitur lorem. Quisque vitae eros diam.",
        "title": "Changements du marché"
      },
      "block-2": {
        "content": "Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit.",
        "title": "Échange de produits dans les contrats"
      },
      "button": "Accéder à mes contrats de volume",
      "card": {
        "link": "clause de non-responsabilité",
        "text": "Lisez notre clause de non-responsabilité pour obtenir plus d'informations sur les variations possibles de cet aperçu."
      },
      "need-help": {
        "content": "Si vous avez des questions complémentaires ou si vous souhaitez obtenir des informations plus détaillées sur vos contrats de volume, contactez votre {link}.",
        "link": "personne de contact ou l'équipe de l'expérience client",
        "title": "Avez-vous besoin d'aide ?"
      },
      "title": "Clause de non-responsabilité"
    },
    "download": {
      "button": "Télécharger",
      "label": "Sélectionnez les informations de contrat que vous souhaitez télécharger"
    },
    "header": {
      "intro": "Obtenez des informations sur vos contrats. Si vous avez des questions, n'hésitez pas à nous contacter.",
      "title": "Mes contrats de volume"
    },
    "products": {
      "header": {
        "billed-qty": "Qté facturée KG",
        "code": "Code LW",
        "contract-qty": "Qté Contr.KG",
        "kg-left": "KG restant",
        "material": "Matériel",
        "open-orders": "Commandes en cours KG",
        "percent-left": "% restant",
        "product": "Nom du produit"
      }
    }
  },
  "dashboard": {
    "invoices": {
      "go-to-my-invoices": "Allez vers mes factures",
      "my-invoices": "Mes factures",
      "open-invoices": "Factures en suspens",
      "upcoming": "Prochain",
      "your-open-invoices": "Vos factures en suspens"
    },
    "orders": {
      "go-to-orders-overview": "Allez vers l'aperçu des commandes et livraisons",
      "last-order": "Dernière commande",
      "my-orders-deliveries": "Mes commandes et livraisons",
      "no-last-order": "Aucune dernière commande disponible",
      "order-date": "Date de commande",
      "order-status": "Statut de commande",
      "your-orders-deliveries": "Vos commandes et livraisons"
    }
  },
  "e-learning": {
    "action": {
      "continue": "Continuer",
      "enroll": "S'inscrire",
      "view": "Visualiser"
    },
    "course": {
      "finish": {
        "button": "J'ai terminé ce cours",
        "description": "Veuillez appuyer sur le bouton pour enregistrer que ce cours a été terminé.",
        "title": "Avez-vous terminé ce cours ?"
      },
      "header": {
        "back": "Retour à l'aperçu",
        "status": "Statut :"
      },
      "related": {
        "default-title": "Autres cours"
      }
    },
    "minutes": "minutes",
    "overview": {
      "empty": "Aucun cours trouvé",
      "search-bar": {
        "category": {
          "all": "Tout",
          "placeholder": "Catégorie : Tout"
        },
        "duration": {
          "all": "Tout",
          "more-than": "Plus de",
          "placeholder": "Durée : Tout"
        },
        "result-title": "({count}) Résultats de recherche pour : | ({count}) Résultats de recherche pour : | ({count}) Résultats de recherche pour : ",
        "search": {
          "placeholder": "Recherche..."
        },
        "status": {
          "all": "Tout",
          "placeholder": "Statut : Tout"
        }
      },
      "title": "Apprentissage en ligne"
    },
    "status": {
      "completed": "Terminé",
      "in-progress": "En cours",
      "not-started": "Pas encore commencé"
    }
  },
  "eatThis": {
    "download": "télécharger maintenant",
    "open": "ouvrir"
  },
  "error": {
    "error_404": {
      "title": "Oups, page introuvable"
    },
    "error_500": {
      "title": "oups, erreur 500"
    },
    "general": {
      "subtitle": "il semble que cette page ne fonctionne pas",
      "title": "oups, erreur inconnue"
    }
  },
  "footer": {
    "copyright": "© {year} Tous droits réservés Lamb Weston",
    "navigation": {
      "privacy": "Confidentialité",
      "profile": "Profil",
      "terms-and-conditions": "Conditions générales"
    }
  },
  "general": {
    "for": "pour",
    "interface": {
      "back": "Retour",
      "cancel": "Annuler",
      "close": "Fermer",
      "remove": "Retirer",
      "save": "Sauvegarder",
      "update": "Mise à jour",
      "none": "Aucun",
      "noResultsFound": "Aucun résultat trouvé",
      "all": "Tous",
      "create": "Créer",
      "next": "Suivant"
    },
    "locale": {
      "de": "allemand",
      "en-GB": "anglais",
      "es": "espagnol",
      "fr": "français",
      "it": "italien",
      "nl": "néerlandais"
    },
    "messages": {
      "error": "Un imprévu est survenu"
    },
    "table": {
      "not-available": "Pas disponible"
    },
    "dialog": {
      "confirm_delete_message": "Êtes-vous sûr de vouloir supprimer cet élément ?"
    }
  },
  "home": {
    "intro": "Au portail clients Lamb Weston.",
    "title": "Bienvenue{fullname},",
    "subtitle": "Fièrement au service de {customerName}"
  },
  "invoices": {
    "column": {
      "amount": "Montant",
      "details": "Info",
      "expire-date": "Date d'expiration",
      "invoice-nr": "No. de facture",
      "posting-date": "Date comptable",
      "sales-order": "Ordre de vente",
      "sales-order-show": "montrer",
      "status": "Statut  "
    },
    "detail": {
      "label": {
        "amount": "Montant",
        "currency": "Devise",
        "expire-date": "Date d'expiration",
        "invoice-number": "Numéro de facture",
        "order-reference": "Référence de commande",
        "payment-terms-code": "Code des conditions de paiement",
        "payment-terms-description": "Description des conditions de paiement",
        "posting-date": "Date comptable",
        "relevant-bill-to": "Facture pertinente à",
        "relevant-payer": "Payeur pertinent",
        "sales-order-ship-to": "Commande de vente Livraison à",
        "type-commercial": "Type commercial"
      },
      "pdf-download": "Télécharger PDF de facture",
      "sales-order": {
        "close": "Fermer message",
        "order-overview": "Allez vers Mes commandes",
        "title": "Facture {invoice} - Commande de vente"
      },
      "show-sales-order": "Montrez commande de vente"
    },
    "empty": "Aucune facture disponible",
    "header": {
      "intro": "Sur cette page, vous pouvez trouver et télécharger vos factures. Cliquez sur une ligne pour obtenir plus d'informations.",
      "title": "Mes factures"
    },
    "search-bar": {
      "placeholder": {
        "all-invoices": "Toutes les factures",
        "filter": "Filtrer les factures",
        "search": "Recherche en cours …"
      },
      "total": "Total",
      "total-filtered": "Total filtré"
    },
    "status": {
      "before due": "Paiement dû",
      "cleared": "payé",
      "days-till-due-date": "{count} jours|{count} jour|{count} jours",
      "due date": "échéance",
      "overdue": "en retard",
      "reversed": "inversé"
    }
  },
  "menuEngineering": {
    "categories": {
      "laggard": "retardataire",
      "runner": "coureur",
      "sleeper": "dormeur",
      "winner": "vainqueur"
    },
    "imageAlt": {
      "icon": "Icône catégorie chef",
      "laggard": "Catégorie chef retardataire",
      "runner": "Catégorie chef coureur",
      "sleeper": "Catégorie chef dormeur",
      "winner": "Catégorie chef vainqueur"
    },
    "label": {
      "addDishEquation": "Votre plat a été ajouté à l’équation",
      "categoryResult": {
        "intro": "Vous trouverez ci-dessous les résultats de vos plats dans les quatre catégories de",
        "link": "Conception de menu",
        "outro": "Cliquez sur la catégorie pour voir lesquels de vos plats relèvent de cette catégorie et recevez des conseils sur l’optimisation de vos plats."
      },
      "companySeatCount": "Combien de places avez-vous",
      "companyStaffSize": "Quelle est la taille de votre personnel",
      "cost": "Coût des aliments (€)",
      "course": {
        "breakfast": "Petit-déjeuner",
        "dinner": "Dîner",
        "inbetween": "En-cas",
        "lunch": "Déjeuner",
        "snack_time": "Goûter"
      },
      "courseDish": "Plat",
      "dishNotDeleted": "Impossible de supprimer le plat",
      "editDish": "Votre plat a été modifié",
      "goodCalculation": "Nous avons besoin d’au moins 5 plats pour faire un bon calcul.",
      "helpTime": "Temps de préparation (min)",
      "info": {
        "cost": "Le prix total de tous les ingrédients dans le plat.",
        "helpTime": "Temps passé par le personnel de cuisine pour préparer ce plat.",
        "popularity": "Combien d’éléments de ce plat sont vendus chaque semaine.",
        "price": "Le prix de vente du plat sur le menu avant impôts.",
        "time": "Temps passé par le chef pour préparer ce plat."
      },
      "insufficientDishes": "Nous avons besoin d’au moins {count} plats supplémentaires pour faire un bon calcul.",
      "laggard": {
        "demand": "Faible demande",
        "profit": "Faible marge"
      },
      "laggards": "Retardataires",
      "nameOfDish": "Nom du plat",
      "optionRestaurant": "Restaurant",
      "popularity": "Popularité (fois par semaine)",
      "price": "Prix de vente hors TVA (€)",
      "runner": {
        "demand": "Forte demande",
        "profit": "Faible marge"
      },
      "runners": "Coureurs",
      "selectCourse": "Plat",
      "selectCourseLabel": "Choisissez un plat",
      "sleeper": {
        "demand": "Faible demande",
        "profit": "Marge élevée"
      },
      "sleepers": "Dormeurs",
      "thinkOfYourDish": "Pensez à l’un de vos plats. Puis remplissez le formulaire.",
      "time": "Temps passé par le chef (min)",
      "typeOfRestaurant": "Quel type de restaurant avez-vous ?",
      "winner": {
        "demand": "Forte demande",
        "profit": "Marge élevée"
      },
      "winners": "Vainqueurs"
    },
    "overview": {
      "addAnotherDish": "Enregistrer et ajouter un autre",
      "addDish": "Ajouter un plat",
      "addDishEquation": "Ajouter un plat à l’équation",
      "calculateNow": "Calculer maintenant",
      "cancel": "Annuler",
      "categoryCompare": "Par rapport à d’autres plats dans votre marché, votre plat s’avère être un",
      "categoryResult": {
        "intro": "Il s’agit des",
        "outro": "plats de votre menu"
      },
      "deleteProfile": "Vous êtes sur le point de supprimer votre profil",
      "dishes": "Plats",
      "menuEngineering": "Conception de menu",
      "results": "Résultats",
      "save": "Enregistrer",
      "showResults": "Afficher les résultats",
      "startMenuEngineering": "Commencez à concevoir votre menu",
      "testValueDishes": "Testez la valeur de vos plats",
      "typeOfRestaurant": "Type de restaurant",
      "yourDish": "Votre plat"
    },
    "placeholder": {
      "typeOfRestaurant": "Steakhouse, pizzeria, etc."
    },
    "results": {
      "back-to-results": "Retour à mes résultats",
      "title": "Mes résultats de conception de menu"
    },
    "try-out": {
      "dish-form": {
        "subtitle": "Pensez à l’un de vos plats. Puis remplissez le formulaire.",
        "title": "2. Votre plat"
      },
      "hero": {
        "subtitle": "La conception de menu permet d’évaluer vos plats sur le menu et d’avoir un aperçu des plus et des moins performants.",
        "title": "Testez la valeur réelle de vos plats"
      },
      "intro": {
        "text": "La conception de menu compare les plats entre eux. Par conséquent, vous aurez toujours des vainqueurs, des dormeurs, des coureurs et des retardataires. Pour obtenir un résultat fiable, comparez uniquement des plats similaires du menu, tels que ceux de la catégorie « plats de résistance ».",
        "title": "Conception de menu",
        "try": "Essayez pour 1 plat ci-dessous !"
      },
      "restaurant-type": {
        "label": "Pouvez-vous nous indiquer quel restaurant ?",
        "subtitle": "Quel type de restaurant avez-vous ?",
        "title": "1. Type de restaurant"
      },
      "result": {
        "sign-up": "Rejoignez-nous pour comparer vos plats"
      }
    }
  },
  "navigation": {
    "approved-products": "Portefeuille {company}",
    "back-to-overview": "Retour à l’aperçu",
    "best-practices": "Pratiques d’excellence/Playbook",
    "container-calculation": "Calcul de conteneur",
    "dashboard": "Tableau de bord",
    "e-learning": "Apprentissage en ligne",
    "eat-this": "Eat This!",
    "lwm-company-information": "Société Lamb Weston",
    "lwm-contact": "Contacts Lamb Weston",
    "market-activations": "Activations de marché",
    "menu-engineering": {
      "add-dish": "Ajouter un plat",
      "main": "Menu d'ingénierie",
      "my-results": "Mes résultats",
      "try-out": "Tester la valeur réelle de vos plats"
    },
    "my-agreements": "Mes accords",
    "my-claims": "Mes réclamations",
    "my-invoices": "Mes factures",
    "my-orders": "Mes commandes et livraisons",
    "my-volume-contracts": "Mes contrats de volume",
    "new-products": "Innovations et tendances",
    "partnership": "Partenariat {company}",
    "permission-mgt": "Gestion des permissions",
    "product-information": "Informations de produit",
    "products-for": "Portefeuille {company}",
    "settings": {
      "main": "Paramètres",
      "my-profile": "Mon profil"
    },
    "sign-out": "Se déconnecter",
    "sustainability": "Programme de développement durable",
    "training": "Exploitation et formation",
    "trend-information": "Informations sur les tendances",
    "user-management": "Gestion des utilisateurs",
    "dock-scheduler": "planificateur de quai",
    "dock-scheduler-booking": "Aperçu de la réservation",
    "dock-scheduling-rules": "Règles de planification des quais"
  },
  "onboarding": {
    "authenticator": {
      "error": {
        "InvalidParameterException": "Le code de validation doit comporter 6 caractères.",
        "unknown": "Quelque chose s'est mal passé, veuillez réessayer."
      },
      "finish": "Terminer",
      "qr-description": "Scannez le code QR avec votre application d'authentification pour obtenir le code MFA.",
      "qr-title": "Code MFA",
      "step-title": "Définir le jeton d'authentification",
      "steps": "Téléchargez l'application Google authenticator dans le magasin Apple ou Android|Appuyez sur l'icône \"+\"|Sélectionnez \"Scanner le code QR\"|Entrez le code de l'application dans le champ \"Code de vérification\".",
      "title": "Application Authenticator"
    },
    "change-mfa": "Modifier",
    "finished": {
      "features-enabled": "Toutes les fonctionnalités du portail sont maintenant disponibles.",
      "finish": "Aller au tableau de bord",
      "intro": {
        "authenticator": "Merci d'avoir configuré votre authentification multifactorielle.\nÀ partir de maintenant, vous pouvez vous connecter en utilisant l'authentification multifactorielle avec votre application Authenticator.",
        "sms": "Merci d'avoir configuré votre authentification multifactorielle.\n\nÀ partir de maintenant, vous pouvez vous connecter en utilisant l'authentification multifactorielle avec un message texte sur votre téléphone."
      },
      "title": "Authentification vérifiée !"
    },
    "mfa-preference": "Préférence pour l'authentification multifactorielle",
    "none": {
      "description": "Si vous ne définissez pas de méthode d'authentification multifactorielle, vous ne pouvez utiliser que les fonctionnalités du portail qui ne la nécessite pas. Si vous continuez sans définir de méthode d'authentification multifactorielle, cette fenêtre contextuelle apparaîtra à nouveau lors de votre prochaine visite.",
      "finish": "Utiliser sans MFA",
      "title": "Ne pas activer la méthode MFA"
    },
    "sms": {
      "change-phone": "Modifier le numéro de téléphone",
      "code-sent": "Nous avons envoyé un code sur votre téléphone.",
      "finish": "Terminer",
      "request-code": "Demander le code",
      "steps": "Saisissez votre numéro de téléphone et appuyez sur Demander le code|Dans quelques secondes, vous devriez recevoir un message texte avec un code de vérification|Saisissez le code de vérification et appuyez sur Terminer pour activer.",
      "title": "Messagerie texte SMS"
    },
    "welcome": {
      "buttons": {
        "authenticator": {
          "label": "(utilisez un code QR et une application MFA pour enregistrer un jeton sur votre appareil mobile)",
          "type": "Application Authenticator"
        },
        "none": {
          "label": "",
          "type": "Ne pas activer la MFA"
        },
        "sms": {
          "label": "(recevoir un code sur votre appareil mobile).",
          "type": "Messagerie texte SMS"
        }
      },
      "explanation-description": "L'authentification multifactorielle (MFA) ajoute une couche supplémentaire de protection en plus de votre nom d'utilisateur et de votre mot de passe. Pour activer l'authentification par SMS, veuillez fournir un numéro de mobile valide ci-dessus.",
      "explanation-title": "Préférence pour l'authentification multifactorielle",
      "recommend-description": "Pour des raisons de sécurité, nous vous recommandons également d'utiliser l'authentification multifactorielle.",
      "required-description": "Bienvenue sur votre portail client ! Afin d'accéder à toutes les fonctionnalités du portail client, une authentification multifactorielle est requise. ",
      "title": "Bienvenue !"
    }
  },
  "orders": {
    "card": {
      "footer": {
        "order-again": "Commander ces produits à nouveau",
        "reorder": "Voulez-vous à nouveau commander cette commande ? Cliquez sur le bouton \"Commander à nouveau ces produits\".",
        "summary-info": "* La composition de la commande peut varier en fonction de la disponibilité des stocks ; la confirmation des articles et des quantités suivra. Lamb Weston et ses partenaires logistiques feront tout leur possible pour respecter la date de livraison souhaitée, mais ils vous communiqueront ultérieurement la date de livraison réelle."
      },
      "header": {
        "bill-of-lading": "Connaissement :",
        "close": "fermer",
        "container-numbers-long": "Numéros de conteneurs ({count})",
        "container-numbers-short": "N°",
        "more": "plus",
        "order-city": "Destination :",
        "order-date": "Date de commande :",
        "order-no": "LW #: ",
        "order-ref": "Réf. de commande :",
        "order-reference": "Référence de commande :",
        "products-to-order": "Produits à commander"
      },
      "status": {
        "delivery-date": "Livraison :",
        "label": "Statut :",
        "more-info": "plus d'informations sur le statut de la commande"
      }
    },
    "group": {
      "last-order": "Votre dernière commande",
      "see-products": "cliquez pour voir les produits"
    },
    "header": {
      "intro": "Ci-dessous vous avez la possibilité de remplir vos nouvelles commandes, d'avoir un aperçu de l'historique de vos commandes ou de rapidement commander à nouveau une commande antérieure. ",
      "new-order-button": "Placer une nouvelle commande",
      "title": "Mes commandes"
    },
    "new": {
      "confirm-dialog": {
        "button": "Fermer le message",
        "message": "La composition de la commande sera confirmée par notre service d'assistance à la clientèle. Cela peut prendre une minute avant que votre commande ne soit affichée dans l'aperçu des commandes.",
        "title": "Merci d'avoir passé commande chez Lamb Weston"
      },
      "footer": {
        "back": "Retourner",
        "cancel": "Annuler",
        "confirm": "Confirmer la commande",
        "next": "Suivant",
        "recalculate": "Recalculer"
      },
      "preferred-warehouse": "**Vous avez sélectionné l'entrepôt : {code},** en raison de cette sélection, pour cette commande, vous pouvez **uniquement commander des produits de cet entrepôt.** Si vous souhaitez commander des produits **d'un autre entrepôt,** veuillez **créer une commande séparée.**",
      "help-text": "La désignation des produits consiste en la taille des découpes et le poids des caisses.",
      "intro": "Vous pouvez rapidement et facilement passer vos commandes. Une fois que la commande a été entrée dans le système et traitée, vous serez contacté par notre service \"Expérience client\" pour les détails de paiement et de livraison.",
      "products-title": "Gamme de produits Lamb Weston",
      "products-unavailable": {
        "button": "Aller vers la sélection de produit",
        "item-label": "Pas disponible",
        "message": "Votre commande actuelle comprend un produit qui n'est plus disponible. Veuillez sélectionner un autre produit sur l'écran de sélection des produits. Nous avons ajouté les autres produits de la commande précédente à votre liste de commande.",
        "title": "Commander à nouveau ces produits - {count} produit(s) non disponible(s)"
      },
      "repeat-button": {
        "large1": "Voulez-vous répéter une commande précédente ?",
        "large2": "Retour à l'aperçu des commandes",
        "small": "répéter la commande ?"
      },
      "steps": {
        "order-reference-and-shipping": "Référence de la commande et expédition",
        "order-summary-and-confirmation": "Résumé et confirmation de la commande",
        "select-products": "Sélectionner les produits"
      },
      "suggest-fill-scale": {
        "footer": {
          "message": "Pour accepter, cliquez sur le bouton orange. Vous êtes libre d'effectuer d'autres ajustements en modifiant la quantité de n'importe quel article de la liste ou vous pouvez ignorer notre suggestion et passer à l'étape suivante du processus de commande.",
          "title": "Nous pouvons optimiser votre commande ! Nous avons fait une suggestion pour vous afin que votre commande corresponde à la prochaine échelle de volume de commande."
        },
        "tooltip": {
          "message": "Ajoutez **+{quantity}** palette(s) pour bénéficier d'un taux de fret plus bas.",
          "title": "Nous pouvons optimiser votre commande !"
        }
      },
      "suggest-fill-truck": {
        "footer": {
          "message": "Pour accepter, cliquez sur le bouton orange. Vous êtes libre d'effectuer d'autres ajustements en modifiant la quantité de n'importe quel article de la liste ou vous pouvez ignorer notre suggestion et passer à l'étape suivante du processus de commande.",
          "title": "Nous pouvons optimiser votre commande ! Nous avons fait une suggestion pour vous afin que votre commande remplisse le camion."
        },
        "tooltip": {
          "message": "Ajoutez **+{quantity}** palette(s) pour remplir le camion.",
          "title": "Nous pouvons optimiser votre commande !"
        }
      },
      "suggest-remove": {
        "footer": {
          "message": "Nous avons fait une suggestion pour vous sur la base de votre ligne de commande la plus élevée. Pour accepter, cliquez sur le bouton orange. Vous êtes libre d'effectuer d'autres ajustements en modifiant la quantité de n'importe quel élément de la liste. Cliquez sur recalculer lorsque vous avez ajusté votre commande pour continuer.",
          "title": "Vous avez dépassé le poids maximal du camion de {quantity} palette(s) ({exceededWeight} kg, palettes comprises)."
        },
        "tooltip": {
          "message": "Réduisez la quantité pour cet article de **-{quantity}**. Annulez pour réduire la quantité pour les autres articles.",
          "title": "Vous avez dépassé le poids maximal du camion."
        }
      },
      "suggestion": {
        "accept": "Accepter",
        "cancel": "Annuler"
      },
      "title": "Nouvelle commande"
    },
    "custom-label-switch": {
      "title": "Afficher les étiquettes originales",
      "description": "Cela affichera les informations originales sur le produit fournies par LambWeston lorsqu'elles sont activées.",
      "checkbox": "Afficher le nom et le numéro d'origine du produit"
    },
    "order-item-list": {
      "header": {
        "art": "Matériel",
        "boxes": "Boîtes",
        "code": "Code LW",
        "warehouse": "Entrepôt",
        "layers": "Couches",
        "pallets": "Palettes",
        "product": "Produit",
        "products": "Produits",
        "quantity": "Quantité",
        "unit-type": "Type d'unité"
      },
      "totals": {
        "grand-total": "Total général",
        "kg": "kg",
        "total-cartons": "Cartons | Carton | Cartons",
        "total-gross-weight": "Poids brut",
        "total-layers": "Couches | Couche | Couches",
        "total-net-weight": "Poids net",
        "total-pallets": "Palettes | Palette | Palettes"
      },
      "unit": {
        "bag": "Sac",
        "car": "Cartons",
        "kg": "kg",
        "lay": "Couches",
        "pal": "Palettes"
      }
    },
    "overview": {
      "closed-orders-title": "Commandes fermées",
      "empty": "Aucune commande disponible",
      "header": {
        "eta-actual": "ETA réelle",
        "eta-booked": "ETA réservé",
        "eta-requested": "Req. ETA",
        "more": "plus",
        "order-city": "Destination",
        "order-date": "Date de commande",
        "order-no": "LW #",
        "order-ref": "Réf. de commande",
        "order-reference": "Référence de commande",
        "order-status": "Statut de commande"
      },
      "open-orders-title": "Commandes ouvertes",
      "search-bar": {
        "query": {
          "placeholder": "Recherche d'une commande spécifique..."
        },
        "status": {
          "all": "Toutes les commandes",
          "placeholder": "Statut de la commande"
        }
      }
    },
    "reference": {
      "intro": "Si vous souhaitez ajouter une référence de commande/un numéro de bon de commande pour votre commande, veuillez remplir le champ de référence de la commande.",
      "number": {
        "max-characters": "(20 caractères max.)",
        "placeholder": "Ajoutez votre numéro de référence de commande",
        "title": "Référence de commande"
      },
      "title": "Référence de votre commande"
    },
    "search-bar": {
      "placeholder": {
        "set-preferred-warehouse": "Définir l'entrepôt préféré",
        "filter-products": "Filtrer les produits",
        "search": "Chercher un produit spécifique ...",
        "search-alt": "chercher  "
      }
    },
    "shipping": {
      "delivery-date": {
        "label": "cette date est une estimation",
        "title": "Date de livraison préférée"
      },
      "eta": {
        "delayed": "retardé",
        "early": "en avance",
        "eta": "HEA :"
      },
      "ship-to": {
        "title": "Expédier à "
      },
      "title": "Expédition"
    },
    "status": {
      "AWS_CREATED": "Reçu par Lamb Weston",
      "DELIVERED": "Livré",
      "SAP_CANCELLED": "Annulé",
      "SAP_CREATED": "Accepté",
      "SAP_PROCESSING": "En cours de traitement",
      "SAP_PROCESSING_PART": "En cours de traitement",
      "SAP_SHIPPED": "Envoyé",
      "SAP_SHIPPED_PART": "Envoyé",
      "SAP_UNKNOWN": "Inconnu",
      "more-info": {
        "AWS_CREATED": "La commande a été complétée et confirmée par le Portail Clients. Un e-mail de confirmation a été envoyé.",
        "DELIVERED": "Confirmation que les marchandises ont été livrées au lieu de livraison.",
        "SAP_CANCELLED": "La commande a été annulée.",
        "SAP_CREATED": "La commande avait été complétée, la sortie créée, aucun blocage, aucun rejet.",
        "SAP_PROCESSING": "La commande est en cours de traitement et de contrôle par LW Expérience Client.",
        "SAP_PROCESSING_PART": "Traitement en cours dans SAP, commande partiellement acceptée.",
        "SAP_SHIPPED": "La commande a complètement été chargée, PGI reçu.",
        "SAP_SHIPPED_PART": "Livraison SAP créée, commande partiellement acceptée.",
        "SAP_UNKNOWN": "Veuillez contacter votre représentant d'Expérience Client pour plus d'informations."
      },
      "part": "partly",
      "partly": "pas complet"
    },
    "summary": {
      "delivery-date": "Expédier à et date de livraison préférée",
      "title": "Résumé de votre commande"
    },
    "warning": {
      "requires-mfa": "La gestion des commandes n'est disponible que pour les utilisateurs ayant activé l'authentification multifactorielle. Vous pouvez configurer votre authentification multifactorielle dans :"
    }
  },
  "permission-mgt": {
    "column": {
      "actions": {
        "delete": "Supprimer",
        "get": "Lire",
        "label": "Actions",
        "post": "Créer",
        "put": "Mettre à jour",
        "tooltip": "Plus d'informations sur les actions"
      },
      "configure": {
        "label": "Configurer",
        "tooltip": "Plus d'informations sur configurer"
      },
      "delete": {
        "label": "Supprimer",
        "tooltip": "Plus d'informations sur supprimer"
      },
      "effect": {
        "label": "Effet",
        "tooltip": "Plus d'informations sur effet"
      },
      "endpoint": {
        "label": "Point de terminaison",
        "tooltip": "Plus d'informations sur point de terminaison"
      },
      "field": {
        "label": "Champ"
      },
      "model": {
        "label": "Modèle"
      },
      "operator": {
        "label": "Opérateur"
      },
      "value": {
        "label": "Valeur"
      },
      "wildcard": {
        "label": "Pour les points de terminaison de type wildcard",
        "tooltip": "Plus d'informations sur wildcard"
      }
    },
    "effect": {
      "allow": "Autoriser",
      "deny": "Refuser"
    },
    "intro": "Gérez les rôles des utilisateurs et leurs permissions. Veuillez d'abord sélectionner un rôle ou ajouter un nouveau rôle.",
    "policies": {
      "add": "Ajouter une nouvelle politique",
      "configure": {
        "actions": "Actions",
        "effect": "Effet",
        "endpoint": "Point de terminaison",
        "for-wildcard-endpoint": "Pour les points de terminaison de type joker",
        "id": "ID",
        "locale": "Locale",
        "title": "Configurer la politique",
        "wildcard": "Wildcard"
      },
      "delete": {
        "cancel": "Annuler",
        "confirm": "Supprimer la politique",
        "message": "Êtes-vous sûr de vouloir supprimer la politique ? Cette action ne peut être annulée.",
        "success": "Politique supprimée avec succès",
        "title": "Suppression de la politique"
      },
      "intro": "Politiques pour ce rôle. Vous pouvez configurer les politiques pour ce rôle en cliquant sur le bouton de configuration et sur le bouton "
    },
    "policy-form": {
      "cancel": "Annuler",
      "endpoint": {
        "label": "Point de terminaison",
        "placeholder": "Sélectionnez un point de terminaison"
      },
      "filters": {
        "add": "Ajouter un nouveau filtre",
        "title": "Filtres de politique"
      },
      "placeholder": {
        "select": {
          "field": "Sélectionner un champ",
          "model": "Sélectionner un modèle",
          "operator": "Sélectionnez un opérateur"
        }
      },
      "submit": "Enregistrer et quitter",
      "title": "Configurer la politique"
    },
    "role": {
      "add": "Ajouter un nouveau rôle",
      "edit": "Modifier le nom du rôle",
      "form": {
        "cancel": "Annuler",
        "error": "Une erreur s'est produite lors de l'enregistrement du rôle",
        "name": {
          "label": "Nom",
          "placeholder": "Saisissez le nom du rôle"
        },
        "submit": "Sauvegarder",
        "success": "Le rôle est sauvegardé",
        "title": "Rôle"
      },
      "placeholder": "Sélectionnez un rôle"
    },
    "select-role": "Veuillez d'abord sélectionner un rôle ou cliquer sur ajouter un nouveau rôle.",
    "title": "Gestion des permissions"
  },
  "product-information": {
    "contact": {
      "description": "Souhaitez-vous obtenir des renseignements sur un nouveau produit ? Ou recevoir des informations sur un produit qui ne figure pas dans votre liste ?",
      "link": "Veuillez contacter le service Expérience Clients",
      "subject": "Portail clients informations de produit"
    },
    "detail": {
      "intro": "Vous trouverez ici toutes les informations de produit sur ce produit.",
      "packaging": {
        "cartons": "cartons",
        "cm": "cm",
        "commodity-code": "HS Code Douane",
        "dimensions": "Dimensions",
        "ean-upc": "Numéro EAN",
        "gross-weight": "Poids brut",
        "height": "hauteur",
        "kg": "kg  ",
        "layers": "couches",
        "length": "longueur",
        "material": "Matériau",
        "net-weight": "Poids net",
        "pallet-type": "Type de palette",
        "shelf-life-code": "Code de durée de conservation",
        "title": "Emballage et dimensions",
        "unit": {
          "bag": "Emballage/sac",
          "car": "Carton",
          "lay": "Couche",
          "pal": "Palette"
        },
        "width": "largeur"
      },
      "product-sheet": {
        "download-button": "Télécharger la fiche produit pdf",
        "information-list": "Informations nutritionnelles|Informations sur les allergènes|Informations sur la cuisson|Informations d'exemples",
        "intro": "Dans cette fiche commerciale de spécification de produit, vous trouverez les informations suivantes.",
        "subtitle": "Fiche commerciale de spécification de produit PDF",
        "title": "Fiche de produit"
      }
    },
    "header": {
      "intro": "Vous trouverez ici les informations de produit disponibles. Appuyez sur plus d'infos pour obtenir des détails des produits.",
      "title": "Informations de produit"
    },
    "list": {
      "empty": "Aucun produit disponible",
      "header": {
        "details": "plus d'infos",
        "download": "télécharger le pdf"
      }
    }
  },
  "profile": {
    "account-settings": {
      "edit": "Modifier les paramètres du compte",
      "title": "Paramètres du compte"
    },
    "edit": "modifier",
    "email": {
      "confirmation-code": "Saisir votre code de confirmation"
    },
    "error": {
      "failed": "Une erreur est survenue lors de la sauvegarde de votre profil",
      "success": "Votre profil a été enregistré",
      "wrongPassword": "Vous avez saisi un mot de passe incorrect"
    },
    "label": {
      "cancel": "Annuler",
      "change-password": "****************",
      "city": "Ville",
      "country": "Pays",
      "edit": "Modifier le profil",
      "email": "Adresse e-mail",
      "firstName": "Prénom",
      "functionTitle": "Titre du poste",
      "lastName": "Nom de famille",
      "locale": "Langue",
      "newPassword": "Nouveau mot de passe",
      "newPasswordRepeat": "Saisir à nouveau le mot de passe",
      "oldPassword": "Ancien mot de passe",
      "phone": "Numéro de téléphone",
      "restaurantCity": "Ville",
      "restaurantCountry": "Pays",
      "restaurantName": "Nom du restaurant",
      "restaurantNumber": "Numéro",
      "restaurantPostalcode": "Code postal",
      "restaurantSeats": "Places",
      "restaurantStreet": "Rue",
      "restaurantTelephone": "Téléphone",
      "restaurantType": "Type de restaurant",
      "restaurantWebsite": "Site Web",
      "save": "Sauvegarder"
    },
    "locale": {
      "change-success": "Votre langue a bien été modifiée"
    },
    "mfa": {
      "current-mfa": "Installée : ",
      "method": {
        "NOMFA": "pas d'authentification multifactorielle",
        "SMS": "Messagerie texte SMS (recevoir un code sur votre appareil mobile)",
        "TOTP": "mot de passe à usage unique (avec application d'authentification)"
      },
      "mfa-description": "L'authentification multifactorielle (AMF) ajoute une couche de protection supplémentaire en plus de votre nom d'utilisateur et de votre mot de passe. Pour activer l'authentification par SMS, veuillez fournir un numéro de téléphone portable valide ci-dessus.",
      "no-mfa-description": "Ne pas activer l'AMF",
      "setup-mfa": "Préférence d'authentification multifactorielle",
      "sms-description": "Messagerie texte SMS (recevez un code sur votre portable). Votre numéro de téléphone doit être correctement configuré.",
      "token-instructions": "Scannez le code QR avec l'appareil photo de votre téléphone ou l'application d'authentification pour obtenir le code AMF.",
      "totp-description": "Mot de passe à usage unique (utilisez un code QR et une application AMF pour enregistrer un token sur votre portable)",
      "totp-info": {
        "1-select-option": "Sélectionnez \"Mot de passe à usage unique\" comme option ci-dessus et cliquez sur \"Configurer AMF\"",
        "2-get-app": "Obtenez le {0} pour votre portable",
        "2-get-app-link": "Application d'authentification Google",
        "3-press-plus": "Appuyez sur l'icône \"+\"",
        "4-select-scan": "Sélectionnez \"Scanner code QR\"",
        "5-enter-code": "Entrez le code de l'application comme \"Code de vérification\".",
        "title": "Comment configurer l'authentification par mot de passe à usage unique"
      }
    },
    "no-profile-placeholder": "Veuillez compléter vos informations de profil pour bénéficier d'une expérience optimale sur le portail client. Cliquez sur l'icône dans le coin droit pour apporter des modifications.",
    "password": {
      "change-success": "Votre mot de passe a bien été modifié",
      "do-not-match": "Les mots de passe ne correspondent pas",
      "invalid": "Le mot de passe doit répondre aux exigences suivantes : Longueur minimale du mot de passe de 6 caractères ; majuscules en alphabet anglais (A-Z) ; minuscules en alphabet anglais (a-z) ; chiffres de base 10 (0-9)."
    },
    "phone": {
      "invalid-phone-number": "Le numéro de téléphone fourni n'est pas accepté comme numéro de téléphone valide.",
      "unknown-error": "Une erreur est survenue, votre numéro de téléphone n'a pas pu être enregistré."
    },
    "placeholder": {
      "city": "C'est-à-dire Londres, Rome",
      "close": "Fermeture",
      "confirmation-code": "123456",
      "country": "Sélectionnez votre pays",
      "email": "mail@chefs.network",
      "functionTitle": "C'est-à-dire Chef, Sous-chef etc.",
      "number": "C'est-à-dire 9, Appartement 12F etc.",
      "open": "Ouverture",
      "password": "Mot de passe",
      "phone": "555-3891203812",
      "restaurant": {
        "seats": "100, par ex.",
        "type": "Steakhouse, pizzeria, etc."
      },
      "staff": "C'est-à-dire 2",
      "street": "C'est-à-dire rue principale",
      "zip": "C'est-à-dire W1U 3BW, 00118 etc."
    },
    "restaurant": {
      "add": "Ajouter un autre restaurant",
      "address": "Adresse",
      "basic": "Base",
      "delete": {
        "confirm": "Supprimer le restaurant",
        "message": "Voulez-vous vraiment supprimer ce restaurant ?",
        "success": "Votre restaurant a été supprimé",
        "title": "Vous êtes sur le point de supprimer un restaurant"
      },
      "delete-success": "Votre restaurant a été supprimé",
      "edit": "Modifier les informations sur le restaurant",
      "save-success": "Votre restaurant a été enregistré",
      "seats": "places",
      "title": "Informations sur le restaurant",
      "type": {
        "(mountain) huts": "Chalets (de montagne)",
        "american diner": "Dîner américain",
        "american_diner": "Dîner américain",
        "bar": "Bar",
        "beach resorts": "Stations balnéaires",
        "beach_resorts": "Stations balnéaires",
        "bistro": "Bistrot",
        "camp sites": "Campings",
        "camp_sites": "Campings",
        "chicken restaurant": "Restaurant de poulet",
        "chicken_restaurant": "Restaurant de poulet",
        "fast food": "Restauration rapide",
        "fast_food": "Restauration rapide",
        "fish Burger": "Hamburger de poisson",
        "fish_burger": "Hamburger de poisson",
        "gourmet restaurant": "Restaurant gastronomique",
        "gourmet_restaurant": "Restaurant gastronomique",
        "grill restaurant": "Restaurant grill",
        "grill_restaurant": "Restaurant grill",
        "hamburger Restaurant": "Restaurant de hamburgers",
        "hamburger_restaurant": "Restaurant de hamburgers",
        "mountain_huts": "Chalets (de montagne)",
        "other": "Autre",
        "pizza restaurant": "Pizzeria",
        "pizza_restaurant": "Pizzeria",
        "pub": "Pub",
        "seafood restaurant": "Restaurant de fruits de mer",
        "seafood_restaurant": "Restaurant de fruits de mer",
        "snack bar": "Snack-bar",
        "snack_bar": "Snack-bar",
        "steakhouse": "Steakhouse"
      }
    },
    "title": "Profil"
  },
  "registration": {
    "label": {
      "password": "Mot de passe",
      "restaurantName": "Veuillez indiquer le nom du restaurant pour lequel vous voulez faire le calcul de Conception de menu."
    },
    "placeholder": {
      "restaurantName": "Nom du restaurant"
    }
  },
  "updates-modal": {
    "general": {
      "close": "Fermer"
    },
    "scopes": {
      "new-product-cold-store": {
        "button-text": "Mise à jour ! Nouvelles fonctionnalités.",
        "read-more": "En savoir plus",
        "title": "Mise à jour ! Nouvelles fonctionnalités.",
        "content": [
          {
            "title": "Chère cliente, cher client,",
            "content": "Nous vous informons que nous avons apporté quelques modifications à notre portail client. Il est désormais possible d'afficher la description et le numéro de votre produit sur le portail client. S'il vous manque des produits ou des descriptions, n'hésitez pas à envoyer ces informations à votre contact chez Lamb Weston.",
            "image": "/img/updates/new-product-cold-store/fr/1.jpg"
          },
          {
            "content": "Si vous voulez seulement voir que les codes et les descriptions de Lamb Weston, vous pouvez cocher cette case.",
            "image": "/img/updates/new-product-cold-store/fr/2.jpg"
          },
          {
            "content": "Dorénavant, nous indiquerons le lieu où se trouve l'entrepôt de livraison.",
            "image": "/img/updates/new-product-cold-store/fr/3.jpg"
          },
          {
            "content": "Si vous avez d&#39;autres questions concernant ces changements, veuillez vous adresser à votre contact chez Lamb Weston."
          }
        ]
      }
    }
  },
  "user-management": {
    "add": {
      "email": {
        "label": "Adresse e-mail",
        "placeholder": "L'adresse e-mail de l'utilisateur …"
      },
      "error-message": "Une erreur est survenue lors de l'ajout de l'utilisateur.",
      "intro": "Veuillez saisir les informations ci-dessous et cliquer sur le bouton \"Ajouter un utilisateur\" pour ajouter un nouvel utilisateur.",
      "locale": {
        "label": "Langue",
        "placeholder": "Sélectionner la langue préférée"
      },
      "mfa": {
        "phone": "Numéro de téléphone",
        "title": "Préférence d'authentification multifactorielle",
        "use-sms-mfa": "Messagerie texte SMS (recevoir un code sur votre appareil mobile)"
      },
      "sap-id": {
        "customer": "Client :",
        "label": "SAP ID",
        "no-portal-access": "Ce client n'a pas accès au portail client.",
        "placeholder": "SAP ID comprend max. 12 caractères…",
        "unknown-sap-id": "Identifiant SAP inconnu"
      },
      "success-message": "L'utilisateur a été ajouté avec succès.",
      "user-group": {
        "label": "User group",
        "placeholder": "Sélectionnez le groupe d'utilisateurs"
      }
    },
    "add-new-user": "Ajouter nouvel utilisateur",
    "change-roles": {
      "form": {
        "cancel": "Annuler",
        "error": "Impossible d’enregistrer les rôles d’utilisateur",
        "label": "Modifier le(s) rôle(s)",
        "placeholder": "Ajouter un rôle",
        "remove": "Supprimer ce rôle",
        "submit": "Enregistrer",
        "success": "Les rôles d’utilisateur ont bien été enregistrés"
      }
    },
    "change-user-group": {
      "form": {
        "cancel": "Annuler",
        "error": "Impossible de modifier le groupe d’utilisateurs",
        "group": {
          "administrators": "Administrateur",
          "any": "Tous",
          "direct-customers": "Client direct",
          "end-users": "Utilisateurs finaux",
          "indirect-customers": "Client indirect",
          "multinationals": "Multinationale",
          "none": "Aucun(e)",
          "dock-scheduling-users": "Utilisateur de planification de quai",
          "dock-scheduling-employees": "Employé à la planification des quais"
        },
        "label": "Modifier le groupe d’utilisateurs",
        "submit": "Enregistrer",
        "success": "Le groupe d’utilisateurs a bien été modifié"
      }
    },
    "column": {
      "customer": "Client",
      "details": "Modifier",
      "email": "E-mail",
      "first-name": "Prénom",
      "last-name": "Nom de famille",
      "status": "Statut",
      "user-group": "User group",
      "vendor": "Partenaire"
    },
    "details": {
      "change-roles": "Modifier les rôles",
      "change-user-group": "Modifier le groupe d’utilisateurs",
      "impersonate": "Emprunter l’identité de cet utilisateur",
      "language": "Langue :",
      "manage-user-intro": "Vous pouvez réinitialiser le mot de passe de cet utilisateur ou l'authentification à deux facteurs en cliquant sur les boutons ci-dessous.",
      "manage-user-title": "Gérer cet utilisateur",
      "reset-mfa": "Réinitialiser 2FA",
      "reset-password": "Réinitialiser le mot de passe",
      "sap-id": "SAP ID :",
      "sap-id-error": "Le SAP ID n'a pas pu être modifié",
      "sap-id-placeholder": "Ajouter SAP ID",
      "sap-id-success": "Le SAP ID a été modifié",
      "status": {
        "active": "Actif",
        "inactive": "Inactif"
      },
      "toggle-active-intro": "En activant le bouton ci-dessous, vous pouvez activer ou désactiver l'utilisateur.",
      "toggle-active-title": "Activer et désactiver utilisateur"
    },
    "group": {
      "administrators": "Administrateurs",
      "direct-customers": "Clients directs",
      "end-users": "Utilisateurs finaux",
      "indirect-customers": "Clients indirects",
      "dock-scheduling-users": "Utilisateur de planification de quai",
      "dock-scheduling-employees": "Employé à la planification des quais"
    },
    "group-short": {
      "administrators": "Admin",
      "any": "Tous",
      "direct-customers": "Client direct",
      "end-users": "Utilisateurs finaux",
      "indirect-customers": "Client indirect",
      "multinational": "Multinationale",
      "none": "Aucun(e)",
      "dock-scheduling-users": "Utilisateur de planification de quai",
      "dock-scheduling-employees": "Employé à la planification des quais"
    },
    "impersonate": {
      "bar": {
        "impersonating_as": "Vous empruntez actuellement l’identité de",
        "stop": "arrêter l’emprunt d’identité"
      },
      "dialog": {
        "cancel": "Annuler",
        "confirm": "Emprunter l’identité",
        "message": "Êtes-vous sûr de vouloir emprunter l’identité de \"{email}\" ?",
        "title": "Emprunter l’identité de l’utilisateur"
      }
    },
    "intro": "Gérez vos utilisateurs. Cliquez sur la ligne d'un utilisateur pour obtenir plus d'informations ou pour connaître les potentielles actions de l'utilisateur.",
    "reset-mfa": {
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "error": "Une erreur est survenue lors de la réinitialisation de l'authentification à deux facteurs.",
      "message": "Êtes-vous certain de vouloir réinitialiser l'authentification à deux facteurs pour cet utilisateur ?",
      "success": "L'authentification à deux facteurs a été réinitialisée.",
      "title": "Réinitialiser l'authentification à deux facteurs"
    },
    "reset-password": {
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "error": "Une erreur est survenue lors de la réinitialisation du mot de passe.",
      "message": "Êtes-vous certain de vouloir réinitialiser le mot de passe de cet utilisateur ?",
      "success": "Le mot de passe a été réinitialisé.",
      "title": "Réinitialiser le mot de passe"
    },
    "search-bar": {
      "placeholder": {
        "all-user-groups": "All user groups",
        "search": "Recherche en cours …",
        "search-alt": "Chercher",
        "users": "Utilisateurs"
      }
    },
    "status": {
      "active": "actif",
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "inactive": "inactif",
      "message": "Êtes-vous certain de vouloir modifier le statut de l'utilisateur ?",
      "title": "Activer et désactiver l'utilisateur"
    },
    "title": "Gestion des utilisateurs",
    "update-vendor-button": "Mettre à jour le partenaire",
    "vendor-label": "Partenaire",
    "vendor-tooltip": "Il n’existe actuellement aucune intégration directe avec le système SAP du fournisseur. \nLa définition d'une valeur permet à un administrateur de créer des réservations pour ce partenaire en fonction de cette valeur.",
    "product-groups-label": "Groupes de produits",
    "update-product-groups-button": "Mettre à jour les groupes de produits"
  },
  "validation": {
    "ext": "Seuls les fichiers avec l'extension '{ext}' sont acceptés.",
    "required": "Ce champ est obligatoire",
    "totalSize": "Vous ne pouvez pas télécharger plus de {totalSize}Mb",
    "quarterly": "Les mois sélectionnés ne forment pas un trimestre valide",
    "no-special-characters": "L'entrée ne peut pas contenir de hashtags, de guillemets, d'astérisques ou de virgules.",
    "password": "Le mot de passe doit contenir au moins {length} caractères",
    "password-repeat": "Les mots de passe ne correspondent pas",
    "email": "Veuillez entrer une adresse e-mail valide",
    "max": "Ce champ doit contenir au maximum {max} caractères.",
    "afterTime": "L'heure de fin doit être postérieure à l'heure de début",
    "min": "Ce champ doit comporter au moins {min} caractères."
  },
  "dock-management": {
    "dock-scheduler-title": "Planificateur de quai",
    "select-location": "Emplacement",
    "select-day": "Jour",
    "dock-scheduler-no-data": "Sélectionnez un lieu et un jour pour consulter et réserver un créneau horaire",
    "dock-schedule-table-cell-your-booking": "Votre réservation",
    "dock-schedule-table-cell-booked-by-other": "Réservé",
    "dock-schedule-table-cell-closed": "Fermé",
    "error-fetching-locations": "Échec de la récupération des emplacements",
    "error-fetching-dock-schedule": "Échec de la récupération du planning",
    "docking-dialog": {
      "booking-id": "@:brand.name référence de réservation",
      "license-plate": "Plaque d'immatriculation",
      "nationality": "Nationalité",
      "remarks": "Remarques",
      "create-button": "Livre",
      "title": "Amarrage pour {dock} à {location}",
      "nationality-placeholder": "Choisissez une nationalité",
      "remarks-placeholder": "Par exemple des instructions de chargement ou des remarques",
      "supplier-placeholder": "Par exemple Lamb Weston",
      "license-plate-placeholder": "Par exemple 22-BDS-02",
      "confirm-dialog": {
        "message": "Êtes-vous sûr de vouloir supprimer cette réservation ? \nCelui-ci sera supprimé pour tout le monde."
      },
      "transporter": "Transporteur",
      "booking-id-tooltip": "Numéro de commande entrant/sortant ou de bon de commande.",
      "error-remove-booking-validation": "L'annulation n'est pas autorisée dans le délai prévu. \nVeuillez contacter votre personne de contact au sein de @:brand.name",
      "partner-placeholder": "Choisissez un partenaire",
      "partner": "Au nom de"
    },
    "error-fetching-bookings": "Échec de la récupération des réservations",
    "success-creating-booking": "Plage horaire réservée avec succès",
    "error-creating-booking": "Échec de la réservation d'un créneau horaire",
    "success-deleting-booking": "Réservation supprimée avec succès",
    "error-deleting-booking": "Échec de la suppression d'une réservation",
    "success-updating-booking": "Réservation mise à jour avec succès",
    "error-updating-booking": "Échec de la mise à jour d'une réservation",
    "dock-schedule-table-cell-no-longer-available": "Ce créneau horaire n'est plus disponible car il se situe en dehors de la fenêtre de réservation autorisée.",
    "dock-schedule-table-cell-loading-reference-not-found": "Le numéro de référence n'a pas pu être trouvé",
    "dock-scheduler-closed-day": "Le site est fermé toute la journée.",
    "dock-schedule-table-lock-dock-tooltip": "Vous ne pouvez pas fermer ce quai, car il y a déjà des réservations effectuées ce jour",
    "error-unlocking-dock": "Échec du déverrouillage du dock",
    "error-locking-timeslot": "Échec du verrouillage du quai",
    "select-booking-period": "Période de réservation",
    "error-fetching-notifications": "Échec de la récupération des notifications",
    "location-notifications": {
      "confirm-dialog": {
        "message": "Êtes-vous sûr de vouloir supprimer cette notification ?"
      },
      "add-notification": "Créer une notification"
    },
    "notification-dialog": {
      "title": "Notification",
      "message": "Message",
      "is-active": "Est actif"
    },
    "success-deleting-notification": "Notification supprimée avec succès",
    "error-deleting-notification": "Échec de la suppression de la notification",
    "success-creating-notification": "Création réussie d'une notification",
    "error-creating-notification": "Échec de la création d'une notification",
    "success-updating-notification": "Notification mise à jour avec succès",
    "location-settings-dialog": {
      "title": "Paramètres du site",
      "cutoff-time": "Heure limite"
    },
    "success-updating-cutoff-time": "Heure limite mise à jour avec succès",
    "error-updating-cutoff-time": "Échec de la mise à jour de l'heure limite",
    "cutoff-time-label": "Les réservations pour le lendemain ferment à {time}",
    "error-updating-notification": "Échec de la mise à jour de la notification",
    "error-fetching-partners": "Échec de la récupération des partenaires",
    "booking-overview-title": "Aperçu de la réservation",
    "select-docks": "Quais",
    "export-bookings-button": "Télécharger",
    "export-bookings-subtitle": "Fichier XLSX",
    "export-bookings-title": "Téléchargez vos réservations passées",
    "export-bookings-error": "Échec de l'exportation",
    "booking-overview-table": {
      "date": "Date",
      "time": "Temps",
      "location": "Emplacement",
      "dock": "Quai",
      "reference-number": "Référence de réservation",
      "partner-id": "Partenaire externe"
    },
    "dock-booking-overview-no-data": "Aucune donnée",
    "dock-scheduling-rules-title": "Règles de planification des quais",
    "add-dock-scheduling-rule": "Nouvelle règle de planification des quais",
    "schedule-overview-table": {
      "collapseTrigger": "{name} ({count} règles)",
      "no-data": "Aucune règle n'a encore été créée."
    },
    "schedule-dialog": {
      "step-1-instructions": "Choisissez un emplacement, un quai et un groupe de produits pour créer une nouvelle règle",
      "title": "Règles de planification des quais",
      "step-2-location": "Emplacement",
      "step-2-selected-docks": "Quais",
      "step-2-selected-product-groups": "Groupes de produits",
      "location": "Emplacement",
      "docks": "Quais",
      "product-groups": "Groupes de produits"
    },
    "error-fetching-product-groups": "Échec de la réception des groupes de produits",
    "error-updating-rule": "Échec de la mise à jour de la règle",
    "success-updating-rule": "Règle mise à jour avec succès",
    "error-creating-rule": "Échec de la création d'une règle",
    "success-creating-rule": "Règle créée avec succès",
    "error-deleting-rule": "Échec de la suppression de la règle",
    "success-deleting-rule": "Règle supprimée avec succès",
    "error-fetching-rules": "Échec de la réception des règles",
    "error-fetching-rule": "Échec de la réception des règles"
  },
  "days": {
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "sunday": "Dimanche"
  },
  "userMgtStore": {
    "userVendorUpdated": "La mise à jour du partenaire a réussi",
    "userProductGroupUpdated": "Mise à jour réussie des groupes de produits"
  },
  "captcha": {
    "error": "Une erreur s'est produite lors du contrôle de sécurité. Veuillez actualiser la page et réessayer.",
    "title": "Vérification de sécurité",
    "subtitle": "Veuillez compléter la vérification ci-dessous pour continuer"
  }
}
